import {
  DataTableAssign,
  DataTableAssignProps,
} from "@/components/custom/data-table/data-table-assign";
import { SiteGroupsTableContext } from "./-site-groups-table-context";

export function SiteGroupsTable(props: Omit<DataTableAssignProps, "context">) {
  return (
    <DataTableAssign
      context={SiteGroupsTableContext}
      pageOptions={[50, 100, 200]}
      {...props}
      stickyHeader={true}
    />
  );
}
